import config from '../config.js'
const API_KEY = config.googleApiKey()
const CALLBACK_NAME = "initMap";

let initialized = !!window.google;

export default function init() {
  return new Promise((resolve, reject) => {
    if (initialized) {
      return resolve(window.google);
    }

    initialized = true;
    // The callback function is called by
    // the Google Maps script if it is
    // successfully loaded.
    window[CALLBACK_NAME] = () => resolve(window.google);
    // We inject a new script tag into
    // the `<head>` of our HTML to load
    // the Google Maps script.
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places,geometry&callback=${CALLBACK_NAME}&v=3.59`;
    script.onload = () => {
      resolve(window.google);
    };
    script.onerror = () => reject(new Error("Script load error: " + src));
    document.querySelector("head").appendChild(script);
  });
}
